/* eslint-disable react-hooks/exhaustive-deps */
import { Button, Descriptions, Modal, Progress } from "antd";
import { useEffect } from "react";

const ViewTriggerProgressModal = ({
  triggerProgress = {},
  isModalOpen = false,
  setIsModalOpen = () => {},
  handleRefreshProgress = () => {}
}) => {
  const handleOk = () => {
    setIsModalOpen(false);
  };

  const handleCancel = () => {
    setIsModalOpen(false);
  };
  const { completedCount = 0, emailsScheduledCount = 0, targetedUsersCount = 1 } = triggerProgress;
  const progress = parseInt((completedCount / (targetedUsersCount || 1)) * 100.0);

  useEffect(() => {
    handleRefreshProgress();
  }, []);

  return (
    <Modal
      title="Trigger Progress"
      open={isModalOpen}
      footer={[]}
      onOk={handleOk}
      onCancel={handleCancel}
      width="1000px"
    >
      <Button
        type="primary"
        onClick={() => {
          handleRefreshProgress();
        }}
      >
        Refresh Progress
      </Button>
      <br />
      <Descriptions title="Progress" bordered column={{ xs: 1, sm: 3 }}>
        <Descriptions.Item label="Pending">{emailsScheduledCount}</Descriptions.Item>
        <Descriptions.Item label="Sent">{completedCount}</Descriptions.Item>
        <Descriptions.Item label="Total">{targetedUsersCount}</Descriptions.Item>
      </Descriptions>
      <Progress percent={progress} status="active" />
    </Modal>
  );
};
export default ViewTriggerProgressModal;
